import { render, staticRenderFns } from "./firstInterviewPartB.vue?vue&type=template&id=3540a9e2&scoped=true"
import script from "./firstInterviewPartB.vue?vue&type=script&lang=js"
export * from "./firstInterviewPartB.vue?vue&type=script&lang=js"
import style0 from "./firstInterviewPartB.vue?vue&type=style&index=0&id=3540a9e2&prod&lang=less&scoped=true"
import style1 from "./firstInterviewPartB.vue?vue&type=style&index=1&id=3540a9e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540a9e2",
  null
  
)

export default component.exports